/* eslint-disable no-param-reassign */

import OMT_UI_ScrollArea from './OMT_UI_ScrollArea';
import OMT_UI_ScrollBarConfig from './OMT_UI_ScrollBarConfig';

export default class OMT_UI_RequestHelpScroll extends OMT_UI_ScrollArea {
  /**
   * constructor
   * @param {Object} config
   */
  constructor(config) {
    super(
      config.scrollRect,
      new OMT_UI_ScrollBarConfig(config.scrollBarWidth, null, config.scrollBarMiddleWidth),
    );
    this._initCustomMask(config.mask.mask, config.mask.proxy);
  }

  /**
   * override and dont create default scroll mask
   */
  _initScrollMask() {}

  /**
   * init custom mask for request help
   * @param {*} graphics
   * @param {*} maskDetectionProxy
   */
  _initCustomMask(graphics, maskDetectionProxy) {
    this._scrollMask = graphics;
    this._scrollMask.enabled = false;

    maskDetectionProxy.enabled = false;
    maskDetectionProxy.cacheAsBitmap = true;
    this._content.maskProxy = maskDetectionProxy;

    this.addChildAt(maskDetectionProxy, 0);
    this.addChildAt(this._scrollMask, 0); // on top of proxy

    this._content.mask = this._scrollMask;
  }

  /**
   * check if a rect is in the mask bounds.
   * @param {Phaser.Rectangle} objectBounds
   * @returns {boolean}
   */
  isWithinMask(objectBounds) {
    return Phaser.Rectangle.intersects(this._content.maskProxy.getBounds(), objectBounds);
  }

  /**
   * destruction method
   */
  destroy() {
    this._content.maskProxy.destroy();
    super.destroy();
  }
}
